<template>
  <div class="page-footer">
    <template v-if="list.length">
      <div class="action-item" @click="$emit('showSwitch')">
        <img class="icon" src="../images/switch_icon.png" />
        <span>切换方案</span>

        <div class="tip-wrap" :class="{ hide: !visible }">
          点这里可以切换其他方案哦~
        </div>
      </div>
      <div class="sep"></div>
    </template>
    <div class="action-item" @click="$emit('showDetail')">
      <img class="icon" src="../images/detail_icon.png" />
      <span>方案详情</span>
    </div>
    <div class="sep"></div>
    <div class="action-item" @click="openKf">
      <img class="icon" src="../../travel/images/service_icon2.png" />
      <span>咨询管家</span>
    </div>
  </div>
</template>

<script>
import qs from "@halobear/utils/qs";
import { open as openKf } from "@/utils/53kf";

const visible = !sessionStorage.getItem("goods-press-tip");

export default {
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    list: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      visible: false,
    };
  },
  emits: ["showSwitch", "showDetail"],
  mounted() {
    this.visible = visible;
    this.timer = setTimeout(() => {
      this.visible = false;
      sessionStorage.setItem("goods-press-tip", "1");
    }, 5000);
  },
  beforeUnmount() {
    clearTimeout(this.timer);
  },
  methods: {
    openKf() {
      const route = this.$route;
      const { phone = "" } = route.query.hall_id
        ? route.query
        : qs.parse(window.location.search.split("?")[1] || "");
      if (phone) {
        window.location.href = `tel:${phone}`;
      } else {
        openKf();
      }
    },
  },
};
</script>

<style lang="less" scoped>
.page-footer {
  width: 750px;
  height: 152px;
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0.3) 0%,
    rgba(0, 0, 0, 0.8) 100%
  );
  border-radius: 12px 12px 0px 0px;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 32px;
  font-size: 28px;
  color: white;
  user-select: none;
  .action-item {
    flex: 1;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: 22px;
    position: relative;
    &:active {
      opacity: 0.88;
    }
  }
  .icon {
    width: 40px;
    height: 40px;
    margin-bottom: 14px;
  }
  .sep {
    flex-shrink: 0;
    width: 4px;
    height: 72px;
    box-shadow: 1px 0px 0px 0px rgba(255, 255, 255, 1);
    background-color: #fff;
    opacity: 0.3;
    transform: scaleX(0.5);
    margin: 0 20px;
  }
  .contact-btn {
    width: 180px;
    height: 72px;
    background: #e03e5d;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    margin-left: 60px;
  }
}

.tip-wrap {
  position: absolute;
  top: -22px;
  left: 8px;
  width: 404px;
  height: 88px;
  transform: translateY(-100%);
  background: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAZQAAABYBAMAAAAgthzoAAAALVBMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADBoCg+AAAAD3RSTlPLAMJXpZ8FSwmpfxYiITj8skc5AAAA1ElEQVR42u3boW2CYRSF4ZO/bZrWnVS0aRG/qWxSDBqFJqwAA8AISAxBImEEVmADtmAMxLfARZDc3LzPBkcd9crzmQr4HVk/Y5XwfNJCRUz0ryKeNFURL+pVRCcAAAAAAAAAAAAAAAAAAAAAAADggSqlOIUCqULZWqGYsFDiWSi8dcCgl5ru4rTkiKXUvDovOeJbao7OS4742rUlb2vnJYec25Q/JyaHfLYpKycmxxwk6d2ZyTEbSdo7Mzlm0Oc+lTYlZpn7VO6Z8tF3Q6cmR22vzu0GJryshlqHeGcAAAAASUVORK5CYII=");
  background-size: 100% 100%;
  font-size: 28px;
  color: white;
  padding: 18px 0;
  line-height: 40px;
  text-align: center;
  // visibility: visible;
  opacity: 1;
  transition: 1s;
  &.hide {
    opacity: 0;
    transform: translateY(-110%);
    // visibility: hidden;
  }
}
</style>
